export default __webpack_public_path__ + "static/media/molecular-biology-solution.680468f6.png";